import React, { useEffect } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import { Form, TextAreaProps } from 'semantic-ui-react';
import { getLabel } from './util';

interface TextAreaFormFiled extends UseControllerProps {
  label?: string | JSX.Element;
  value?: string;
  control: any;
  noErrorMessage?: boolean,
  hideError?: boolean;
}

type TextareaFormFiledProps = TextAreaFormFiled & TextAreaProps;

const TextArea: React.FC<TextareaFormFiledProps> = (props) => {
  const { field, fieldState } = useController(props);
  const fieldTemp = { ...field, ref: null as any };
  const { control, label, rules, defaultValue, hideError, ...textAreaProps } = props;

  function notInViewport(element: any, offset = 0) {
    if (!element) return false;
    const top = element.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset >= window.innerHeight;
  }

  useEffect(() => {
    if (fieldState.error) {
      const element = document.getElementById(field.name);
      if (notInViewport(element)) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'start' });
      }
    }
  }, [fieldState]);

  return (
    <Form.TextArea
      id={fieldTemp.name}
      {...textAreaProps}
      {...fieldTemp}
      value={fieldTemp.value || ''}
      error={Boolean(fieldState.error)}
      label={props.label ? getLabel(label, rules, fieldState) : null}
    />
  );
};
export default TextArea;
